import React, {useEffect, useState} from 'react';
import LinkItem from './LinkItem';
import Teaser from './Teaser';

// eslint-disable-next-line
const LinkSection = ({
                       linkSectionData,
                       crumbsFunction,
                       animation,
                       setRightAni,
                       teasDaRe,
                       activePageId,
                       tabIndex,
                       firstFlyoutLinkRef,
                       focusFirstFlyoutLink,
                       dictionary
                     }: any) => {
  const [data, setData]: Array<any> = useState([]);
  const [teaserData, setTeaserData]: any = useState({});

  // prepare data for items
  const splitUpData = (dataRef: any) => {
    if (dataRef.length) {
      // inject teaser as new data column
      if (!teasDaRe.length) {
        setTeaserData(teasDaRe);
      } else {
        setTeaserData({});
      }

      // set column data to global
      setData(dataRef);
    }
  }

  // callback in parent
  const childCallBack = (dataRef: any) => {
    splitUpData(dataRef);
  }

  // callback in items
  const teaserDataCallback = (dataRef: any) => {
    teasDaRe = dataRef;
    splitUpData(dataRef);
  }

  // callback in items
  const crumbCallBack = (dataRef: any) => {
    crumbsFunction(dataRef);
  }

  //
  useEffect(() => {
    splitUpData(linkSectionData);
  }, [linkSectionData]);

  const getColumnCount = (): number => Object.keys(teaserData).length > 0 ? 2 : 3;
  const getRowCount = (colCount: number): number =>  data.length > 0 ? Math.ceil(data.length / colCount) : 1;
  const getGroupColStyle = () =>  {
    const colCount = getColumnCount();
    return { "--row-count": getRowCount(colCount), "--col-count": colCount, } as React.CSSProperties
  };


  return (
    <>
      <div className="nav__flex">
        <div className="nav__items">
          <ul className="nav-group-col" style={getGroupColStyle()}>
            <LinkItem
              linkItemData={data}
              parentFunction={childCallBack}
              crumbsFunction={crumbCallBack}
              animation={animation}
              setRightAni={setRightAni}
              teaserDataCallback={teaserDataCallback}
              activePageId={activePageId}
              tabIndex={tabIndex}
              firstFlyoutLinkRef={firstFlyoutLinkRef}
              focusFirstFlyoutLink={focusFirstFlyoutLink}
              dictionary={dictionary}
            />
          </ul>
          {teaserData &&
            <Teaser
              teaserData={teaserData}
              setRightAni={setRightAni}
              tabIndex={tabIndex}
            />
          }
        </div>
      </div>
    </>
  )
};

export default LinkSection;
